import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuilding = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 21l18 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 8l1 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 12l1 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 16l1 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 8l1 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 12l1 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M14 16l1 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" })
	]
});
export { SvgBuilding as ReactComponent };
